import { MITEKINPROGRESS } from "Utils/Constants";
import React, { useEffect, useState } from "react";
import { MITEK_TIMEOUTSECONDS } from "Utils/EnvVars";
import { CircularProgress, Stack } from "@mui/material";
import { Typography } from "@pav/pav-products-design-system";
import "./mitek.scss";

const MitekInprogress = (props) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [fade, setFade] = useState(true);

  useEffect(() => {
    const timer = setInterval(() => {
      setFade(false);
      setTimeout(() => {
        setCurrentIndex(
          (prevIndex) => (prevIndex + 1) % MITEKINPROGRESS.length,
        );
        setFade(true);
      }, 1000);

      return () => clearInterval(timer);
    }, 10000);

    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    (async () => {
      let responseMessage = await poll(10000);
      if (window.opener !== null && !window.opener.closed) {
        window.postMessage(responseMessage, "*");
      } else if (
        window.parent !== null &&
        window.parent.frames !== null &&
        window.parent.frames.length > 0
      ) {
        window.parent.postMessage(responseMessage, "*");
      } else {
        if (/android/i.test(navigator.userAgent)) {
          if (typeof window !== undefined) {
            window.postMessage(responseMessage, "*");
          } else if (document !== undefined) {
            document.postMessage(responseMessage, "*");
          }
        } else if (/iPad|iPhone|iPod/.test(navigator.userAgent)) {
          window.postMessage(responseMessage, "*");
        }
      }
    })();
  }, []);

  const poll = async function (ms) {
    console.log("Entered Poll Method");
    let elapsedMilliSeconds = 0;
    console.log(MITEK_TIMEOUTSECONDS);
    const mitekTimeOutInMilliseconds = MITEK_TIMEOUTSECONDS * 1000;
    console.log(mitekTimeOutInMilliseconds);
    console.log("Elapsed Seconds before While Loop" + elapsedMilliSeconds);
    while (elapsedMilliSeconds < mitekTimeOutInMilliseconds) {
      await wait(ms);
      elapsedMilliSeconds = elapsedMilliSeconds + ms;
      console.log("Elapsed Seconds in While Loop" + elapsedMilliSeconds);
    }
    return "timeout";
  };

  const wait = function (ms = 5000) {
    return new Promise((resolve) => {
      setTimeout(resolve, ms);
    });
  };

  return (
    <Stack
      className="mitek-progress"
      alignItems="center"
      gap="var(--spacing-md)"
    >
      <CircularProgress size="52px" />
      <Stack
        gap="var(--spacing-md)"
        alignItems={{ xs: "left", md: "center" }}
        textAlign={{ xs: "left", md: "center" }}
      >
        <Typography className="mitek-in-progress-header">
          We are validating your submission.
        </Typography>
        <Typography weight="bold">Please wait.</Typography>
        <Typography className={`text ${fade ? "fade-in" : "fade-out"}`}>
          {MITEKINPROGRESS[currentIndex]}
        </Typography>
      </Stack>
    </Stack>
  );
};
export default MitekInprogress;
